module.exports = __webpack_public_path__ + "static/phone-slide-5-en-3ce2d460e9826f676c1b6903b8e43a94.png";